import { render, staticRenderFns } from "./icon-arrow-long.vue?vue&type=template&id=e991b9f8&scoped=true&"
import script from "./icon-arrow-long.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-long.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow-long.vue?vue&type=style&index=0&id=e991b9f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e991b9f8",
  null
  
)

export default component.exports